<template>
  <div>
    <div v-if="loadingOverlay === true"><div class="lds-dual-ring"></div></div>
    <div v-else>
      <div class="row">
        <div class="col-md-8">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
      </div>
      <div class="col-md-12">
        <h5>Campaign Contents</h5>
      </div>
      <hr/>

      <!-- Contents -->
      <div v-if="campaignContentsStore.length > 0">
        <div class="card">
          <div class="row" style="padding: 25px">
            <div class="col-sm-6 col-lg-3" v-for="content in campaignContentsStore" :key="content._id">
              <div class="hovereffect post-click" @click="$router.push(`/influencer-campaign/content-detail/`+ content._id)">
                <span style="width:100%">
                  <img v-if="content.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1"
                    :src="s3 + '/' + content.contentUrl" alt class="img-responsive campaign-file"/>
                  <iframe v-else allowfullscreen frameBorder="0"  :src="s3 + '/' + content.contentUrl" class="iframe"/>
                </span>
                <div class="overlay">
                  <div class="overlay-stats">
                    <div style="padding:15px;">
                      <i v-if="content.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1" class="far fa-image"></i>
                      <i v-else class="fas fa-video"></i>
                    </div>
                    <p>Status: {{content.status}}</p>
                    <p class="icon-links">VIEW DETAIL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="card" style="padding: 30px">No campaign files</div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js'
import { config } from '@/config/s3-bucket'
import { mapGetters } from 'vuex'

export default {
  name: 'CampaignContentsBrandList',
  data() {
    return {
      loadingOverlay: false,
      candidateId: '',
      s3: config.s3Url
    }
  },
  created() {
    this.candidateId = this.$route.params.candidateId
    this.loadingOverlay = true
    store.dispatch('getListOfCampaignContent', this.$route.params.campaignId).then(() => {
      this.loadingOverlay = false
    })
  },
  computed: { ...mapGetters(["campaignContentsStore"]) },
}
</script>

<style scoped src="./style/index.css"/>